import React from 'react'

const style = {
  background: 'orange',
  color: 'black',
  margin: '0 auto',
  padding: '0.5rem 2rem',
  textAlign: 'center',
  alignSelf: 'center',
  justifySelf: 'center',
}

const msg = 'کاربر فعلی: '

const LoggedInAs = ({user}) => {
  return (
    <div style={style}>
      <span>{msg}</span>{user && user.username}
    </div>
  )
}

export default LoggedInAs


// WEBPACK FOOTER //
// ./src/components/common/LoggedInAs.js